import { useState } from 'react';
import AccountUpdated from './AccountUpdated';
import UpdateAccountSection from './UpdateAccountSection';

interface UpdateLoginProps {
  username: string
  showUsername: boolean
  showPassword: boolean
  showSecretQuestion: boolean
  showEmail: boolean
  backToLogin: () => void
}

const UpdateLogin = (props: UpdateLoginProps) => {
    const [page, setPage] = useState(0);
    const {username, showUsername, showPassword, showSecretQuestion, showEmail, backToLogin} = props;

    const updateAccount =
      <UpdateAccountSection
          emailVisible={showEmail}
          passwordVisible={showPassword}
          resetLoginFlow={backToLogin}
          secretQuestionVisible={showSecretQuestion}
          showPageCallBack={(code: number) => setPage(code)}
          temporaryUsername={username}
          usernameVisible={showUsername}
      />;

    const accountUpdatedInfoSection =
      <AccountUpdated resetLoginFlow={backToLogin}/>;

    const pages = [updateAccount, accountUpdatedInfoSection];

    return pages[page];
};
export default UpdateLogin;